import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AUTH_CALLBACK_PATH, urlHasAuthCallbackCredentials } from "@/lib/auth-callback";

export default function Home() {
  const navigate = useNavigate();
  useEffect(() => {
    if (urlHasAuthCallbackCredentials(window.location.search, window.location.hash)) {
      navigate(`${AUTH_CALLBACK_PATH}${window.location.search}${window.location.hash}`, { replace: true });
      return;
    }
    navigate("/dashboard", { replace: true });
  }, [navigate]);
  return null;
}
